import { Link } from "react-router-dom";
import { Reveal } from "../components/motion";

const MENTIONS = [
  { title: "Éditeur du site", body: "La Maison de la Charité — Église chrétienne évangélique, Montévrain / Val d'Europe, Seine-et-Marne (77144), France. Les coordonnées complètes de l'association (numéro RNA, adresse du siège) seront précisées ici par les responsables de l'église." },
  { title: "Directeur de la publication", body: "L'équipe responsable de La Maison de la Charité." },
  { title: "Hébergement", body: "Ce site est hébergé sur une infrastructure cloud professionnelle. Les informations détaillées de l'hébergeur seront complétées lors de la mise en production officielle." },
  { title: "Propriété intellectuelle", body: "L'ensemble des contenus de ce site (textes, identité visuelle, éléments graphiques) est la propriété de La Maison de la Charité, sauf mention contraire. Les photographies d'illustration proviennent de banques d'images libres de droits et seront remplacées par des photographies de l'église." },
  { title: "Liens externes", body: "Ce site peut contenir des liens vers des sites tiers (Google Maps, YouTube, réseaux sociaux). La Maison de la Charité n'est pas responsable de leur contenu." },
];

const PRIVACY = [
  { title: "Données collectées", body: "Les formulaires de ce site (demande de prière, première visite, contact, newsletter) collectent uniquement les informations que vous saisissez volontairement : prénom, coordonnées éventuelles et message. Aucun cookie de suivi ou de publicité n'est déposé ; aucune bannière de consentement n'est donc nécessaire." },
  { title: "Finalité", body: "Ces données servent exclusivement à répondre à votre demande : prier pour vous, préparer votre accueil, répondre à votre message ou vous tenir informé si vous l'avez demandé." },
  { title: "Confidentialité des demandes de prière", body: "Les sujets de prière sont traités avec respect et discrétion. Les demandes marquées « confidentielles » ne sont partagées qu'avec la personne chargée de la prière." },
  { title: "Conservation", body: "Les messages sont conservés le temps nécessaire à leur traitement, puis supprimés. Vous pouvez demander la suppression immédiate de vos données à tout moment." },
  { title: "Vos droits (RGPD)", body: "Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Pour l'exercer, utilisez le formulaire de contact du site." },
  { title: "Sécurité", body: "Les formulaires sont protégés contre le spam et les données transitent de manière chiffrée (HTTPS)." },
];

export default function Legal({ kind }) {
  const isPrivacy = kind === "privacy";
  const blocks = isPrivacy ? PRIVACY : MENTIONS;
  return (
    <section data-testid={isPrivacy ? "privacy-page" : "legal-page"} className="container-site pb-24 pt-32 sm:pt-40">
      <Reveal>
        <p className="label-eyebrow">{isPrivacy ? "Vie privée" : "Informations légales"}</p>
        <h1 className="mt-3 font-serif text-4xl tracking-tight text-obsidian sm:text-5xl">
          {isPrivacy ? "Politique de confidentialité" : "Mentions légales"}
        </h1>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-stone-500">
          La Maison de la Charité — Montévrain / Val d'Europe, Seine-et-Marne.
        </p>
      </Reveal>
      <div className="mt-12 max-w-3xl space-y-8">
        {blocks.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.05}>
            <div data-testid={`legal-block-${i}`} className="border-l-2 border-terracotta/40 pl-6">
              <h2 className="font-serif text-xl font-semibold text-obsidian">{b.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-stone-600">{b.body}</p>
            </div>
          </Reveal>
        ))}
        <Reveal>
          <Link data-testid="legal-back-home" to="/" className="btn-outline">Retour à l'accueil</Link>
        </Reveal>
      </div>
    </section>
  );
}
